import {
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
  withJsonpSupport,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, ViewportScroller } from '@angular/common';
import { CustomersModule } from './customers/customers.module';

import { ClipboardModule } from '@angular/cdk/clipboard';
import { AuthServiceService } from './shareModule/services/auth-service.service';
import { TokenInterceptor } from './shareModule/services/auth.interceptor';
import { NgbdSortableHeader } from './shareModule/directive/ngbd-sortable-header/ngbd-sortable-header.directive';
import { ShareModule } from './shareModule/shareModule';
import { RedirectionService } from './shareModule/services/redirection.service';
import { CommunityRedirectGuard } from './customers/util/guard/community-redirect-guard/community-redirect.guard';
import { PageLoaderComponent } from './shareModule/component/page-loader/page-loader/page-loader.component';

import { AdminHomeComponent } from './admin/admin-home/admin-home.component';
import { SchedulingComponent } from './admin/sub-admin/scheduling/scheduling.component';
import { FeedbacksComponent } from './admin/auth/feedbacks/feedbacks.component';
import { NewHomepageComponent } from './admin/new-homepage/new-homepage.component';
import { NewErrorPageComponent } from './admin/new-error-page/new-error-page.component';
import { NewUseCaseComponent } from './admin/new-use-case/new-use-case.component';
import { NewReviewUploadImageComponent } from './admin/new-review-upload-image/new-review-upload-image.component';
import { UserShareReviewLinkComponent } from './admin/user-share-review-link/user-share-review-link.component';
import { ClientShareReviewLinkComponent } from './admin/client-share-review-link/client-share-review-link.component';
import { DashboardAdminComponent } from './admin/layout/dashboard-admin/dashboard-admin.component';
import { AdminHeaderComponent } from './admin/admin-header/admin-header.component';
import { RedeemVoucherComponent } from './admin/auth/redeem-voucher/redeem-voucher.component';
import { SubAddNotesComponent } from './admin/sub-admin/sub-add-notes/sub-add-notes.component';
import { SubSubAdminComponent } from './admin/sub-admin/sub-sub-admin/sub-sub-admin.component';
import { NewHeaderComponent } from './admin/new-header/new-header.component';
import { VouchersComponent } from './customers/vouchers/vouchers.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { BookTimingModalComponent } from './customers/book-timing-modal/book-timing-modal.component';
import { ChatbotService } from './shareModule/component/chat/chatbot/chatbot.service';

import { SocketService } from './socket.service';
import { Router, Scroll } from '@angular/router';
import { filter } from 'rxjs';



const mockWindow = {
  innerWidth: 1024, // Default width for SSR
};

@NgModule({
  declarations: [
    AppComponent,
    NgbdSortableHeader,
    PageLoaderComponent,
    AdminHomeComponent,
    SchedulingComponent,
    FeedbacksComponent,
    SchedulingComponent,
    NewHomepageComponent,
    NewErrorPageComponent,
    NewUseCaseComponent,
    NewReviewUploadImageComponent,
    UserShareReviewLinkComponent,
    ClientShareReviewLinkComponent,
    DashboardAdminComponent,
    AdminHeaderComponent,
    RedeemVoucherComponent,
    SubAddNotesComponent,
    SubSubAdminComponent,
    NewHeaderComponent,
    VouchersComponent,
    BookTimingModalComponent, 
  ],
  bootstrap: [AppComponent],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    ClipboardModule,
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    //BsDatepickerModule.forRoot(),
    // CalendarModule.forRoot({
    //   provide: DateAdapter,
    //   useFactory: adapterFactory,
    // }),
    // ChartsModule,
    //Ng2SearchPipeModule,
    // NgxShimmerLoadingModule,
    // NzIconModule,
    // TooltipModule.forRoot(),
    // AngularFireModule.initializeApp(firebaseEnv.firebaseConfig),
    //AngularFireMessagingModule,
    //AngularFireModule.initializeApp(firebaseEnv.firebase),
    //MessagingModule,

    //AngularFireAuthModule,
    // AngularFirestoreModule,
    ShareModule,
    CommonModule,
    // CustomersModule,
    StoreModule.forRoot({}), // Initialize the store with an empty object
    EffectsModule.forRoot([]), // Initialize root effects
    CustomersModule,
  ],

  providers: [
    SocketService,
    RedirectionService,
    HttpClient,
    CommunityRedirectGuard,
    AuthServiceService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    ChatbotService,
    provideClientHydration(),
    {
      provide: 'WINDOW',
      useFactory: () => (typeof window !== 'undefined' ? window : mockWindow),
    },
  ],
})
export class AppModule {
  constructor(router: Router) {
    router.events
      .pipe(filter((e: any): e is Scroll => e instanceof Scroll))
      .subscribe((e) => {
        // No scrolling actions
      });
  }
}
